export default function Hero() {
  return (
    <section id="hero" className="relative w-full bg-background-50 overflow-hidden">
      {/* Japanese linework - minimal flowing lines */}
      <div className="absolute inset-0 pointer-events-none select-none" aria-hidden="true">
        {/* Top-right: gentle horizontal wind lines */}
        <svg className="absolute top-12 right-[8%] w-48 md:w-64 h-auto text-primary-200/30" viewBox="0 0 260 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 15 Q65 5 130 18 Q195 31 260 12" stroke="currentColor" strokeWidth="1.2" fill="none" />
          <path d="M20 35 Q85 45 150 32 Q215 19 260 38" stroke="currentColor" strokeWidth="0.8" fill="none" />
          <path d="M10 50 Q75 40 140 52 Q205 64 260 48" stroke="currentColor" strokeWidth="0.6" fill="none" />
        </svg>

        {/* Bottom-left: geometric plant line motif */}
        <svg className="absolute bottom-16 left-[6%] w-36 md:w-48 h-auto text-primary-200/25" viewBox="0 0 140 200" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="70" y1="200" x2="70" y2="120" stroke="currentColor" strokeWidth="1" />
          <path d="M70 120 Q50 100 35 80" stroke="currentColor" strokeWidth="0.8" fill="none" />
          <path d="M70 120 Q90 100 105 80" stroke="currentColor" strokeWidth="0.8" fill="none" />
          <path d="M35 80 Q30 65 20 55" stroke="currentColor" strokeWidth="0.6" fill="none" />
          <path d="M35 80 Q45 65 40 50" stroke="currentColor" strokeWidth="0.6" fill="none" />
          <path d="M105 80 Q110 65 120 55" stroke="currentColor" strokeWidth="0.6" fill="none" />
          <path d="M105 80 Q95 65 100 50" stroke="currentColor" strokeWidth="0.6" fill="none" />
        </svg>

        {/* Center-right: subtle vertical lines - bamboo feel */}
        <div className="absolute top-20 right-[20%] flex gap-3 md:gap-4">
          <div className="w-px h-32 bg-primary-300/20"></div>
          <div className="w-px h-24 bg-primary-300/15 mt-4"></div>
          <div className="w-px h-28 bg-primary-300/20 mt-2"></div>
          <div className="w-px h-20 bg-primary-300/10 mt-6"></div>
        </div>

        {/* Bottom-right: gentle arc lines */}
        <svg className="absolute bottom-10 right-[12%] w-44 md:w-56 h-auto text-accent-200/15" viewBox="0 0 200 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 60 Q100 10 200 60" stroke="currentColor" strokeWidth="0.8" fill="none" />
          <path d="M20 70 Q100 25 180 70" stroke="currentColor" strokeWidth="0.6" fill="none" />
          <path d="M40 50 Q100 5 160 50" stroke="currentColor" strokeWidth="0.5" fill="none" />
        </svg>

        {/* Top-left: minimal circle + line */}
        <svg className="absolute top-28 left-[10%] w-16 h-16 md:w-20 md:h-20 text-secondary-200/20" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="40" cy="40" r="35" stroke="currentColor" strokeWidth="0.8" fill="none" />
          <circle cx="40" cy="40" r="20" stroke="currentColor" strokeWidth="0.5" fill="none" />
          <line x1="40" y1="5" x2="40" y2="20" stroke="currentColor" strokeWidth="0.6" />
        </svg>
      </div>

      <div className="relative max-w-3xl mx-auto px-6 md:px-10 pt-32 md:pt-40 pb-16 md:pb-24 text-center">
        {/* Main title - elegant, fine-line, not excessively large */}
        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-light text-foreground-950 leading-[1.15] tracking-tight">
          樹下的日常·日常
        </h1>

        {/* Subtle line accent */}
        <div className="mt-5 flex items-center justify-center gap-3">
          <div className="w-10 h-px bg-foreground-300/40"></div>
          <div className="w-1.5 h-1.5 rounded-full bg-primary-400/50"></div>
          <div className="w-10 h-px bg-foreground-300/40"></div>
        </div>

        {/* Subtitle - refined, elegant, smaller */}
        <p className="mt-6 font-body text-sm md:text-base text-foreground-600 leading-relaxed tracking-wide max-w-sm mx-auto">
          城市太急促，慢下來。<br />找一棵樹，將重量交比佢
        </p>
      </div>
    </section>
  );
}